import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../shared/table/Table';
import TeamInvitationsPage from '../TeamInvitationsPage/containers/TeamInvitationsPage';
import EditDivisionModal from '../../shared/team/EditDivisionModal';
import ErrorMessage from '../../shared/message/ErrorMessage';
import { Helmet } from 'react-helmet';

class TeamMembersPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.loadMembers = this.loadMembers.bind(this);
    this.onSelectPageSize = this.onSelectPageSize.bind(this);
    this.onSelectPage = this.onSelectPage.bind(this);
    this.onRowSave = this.onRowSave.bind(this);
    this.newUser = this.newUser.bind(this);
    this.showEditDivisionModal = this.showEditDivisionModal.bind(this);
    this.hideEditDivisionModal = this.hideEditDivisionModal.bind(this);
    this.loadDivisionMembers = this.loadDivisionMembers.bind(this);
    this.refreshDivisions = this.refreshDivisions.bind(this);
    this.selectDefaultDivision = this.selectDefaultDivision.bind(this);
    this.saveDivisionMembers = this.saveDivisionMembers.bind(this);

    this.table = React.createRef();
    this.teamInvite = React.createRef();
  }

  componentDidMount() {
    this.loadMembers(this.props.team, this.props.page, this.props.pageSize);
  }

  /*
  componentWillReceiveProps(newProps) {
    
    const team = newProps.team;
    const division = newProps.division;

    if (!this.props.division || (division.id !== this.props.division.id)) {
      this.props.set({ division },
      () => {
        this.loadMembers(team, this.props.page, this.props.pageSize);
      });
      return;
    }

    if (team.id !== this.props.team.id) {
      this.loadMembers(team, this.props.page, this.props.pageSize);
    }
  }*/

  componentDidUpdate(prevProps, prevState) {
    const isDifferentTeam = this.props.team && (!prevProps.team || prevProps.team.id !== this.props.team.id);
    const isDifferentDivision =
      this.props.division && (!prevProps.division || prevProps.division.id !== this.props.division.id);

    if (isDifferentTeam || isDifferentDivision) {
      this.loadMembers(this.props.team, this.props.page, this.props.pageSize);
    }
  }

  componentWillUnmount() {
    this.props.set({ dataReturned: false });
  }

  loadMembers(team, page, pageSize) {
    this.props.getMembers(team, page, pageSize);
  }

  onSelectPageSize(pageSize) {
    this.loadMembers(this.props.team, this.props.page, pageSize);
  }

  onSelectPage(page) {
    this.loadMembers(this.props.team, page, this.props.pageSize);
  }

  onRowSave(index, row) {
    this.props.updateUsersGroup(this.props.team, row, this.props.page, this.props.pageSize);
  }

  newUser() {
    this.teamInvite.current.openModal();
  }

  showEditDivisionModal() {
    this.props.set({
      editDivisionModalOpen: true,
    });
  }

  hideEditDivisionModal() {
    this.props.set({
      editDivisionModalOpen: false,
    });
  }

  refreshDivisions() {
    this.loadDivisionMembers(this.props.team, this.props.division, this.props.page, this.props.pageSize);
  }

  selectDefaultDivision() {
    this.props.reloadTeams();
    this.props.set({
      activeDivision: 'All subteams',
    });
    let members = this.props.members;
    members.forEach((member) => {
      member.defaultCheck = false;
    });
    this.props.set({
      members,
    });
  }

  saveDivisionMembers(details) {
    let checkboxValues = this.table.current.getCheckboxValues();
    this.props.updateDivisionMembers(
      this.props.team,
      this.props.activeDivision,
      this.props.members,
      checkboxValues,
      this.props.page,
      this.props.pageSize
    );
  }

  loadDivisionMembers(team, division, page, pageSize) {
    this.props.getDivisionMembers(team, division, page, pageSize, this.props.members);
  }

  render() {
    const hasPermission = this.props.checkPlanPermission('team_management') || false;

    const bulkActions = [
      {
        text: 'Delete selected users',
        className: 'hidden-xs  danger',
        hasPermission,
        onClick: (users) => {
          this.props.deleteTeamUsers(this.props.team, users, this.props.page, this.props.pageSize);
        },
      },
      {
        text: 'Filter by subteam:',
        type: 'select',
        hasPermission,
        className: 'divider filter-subteam-select hidden-xs ',
        options: this.props.formattedDivisions || [],
        value: this.props.activeDivision,
        onChange: (users) => {
          if (this.props.activeDivison !== users.target.value) {
            this.props.set({
              activeDivision: users.target.value,
            });
          }

          if (users.target.value !== '' && users.target.value !== 'All subteams') {
            this.loadDivisionMembers(this.props.team, users.target.value, this.props.page, this.props.pageSize);
          } else {
            let members = this.props.members;
            members.forEach((member) => {
              member.defaultCheck = false;
            });
            this.props.set({
              members,
            });
          }
        },
      },
      {
        text: 'Edit selected subteam',
        hasPermission,
        className: ' hidden-xs ',
        disabled: this.props.activeDivision === '' || this.props.activeDivision === 'All subteams',
        onClick: (users) => {
          this.showEditDivisionModal();
        },
      },
      {
        text: 'Save subteam members',
        className: ' hidden-xs ',
        hasPermission,
        disabled: this.props.activeDivision === '' || this.props.activeDivision === 'All subteams',
        onClick: (users) => {
          this.saveDivisionMembers(users);
        },
      },
      {
        text: 'Add subteam',
        className: ' hidden-xs hidden-sm',
        hasPermission,
        bypassCheck: true,
        onClick: () => {
          this.props.addDivision();
        },
      },
    ];

    const members = this.props.members || [];
    const groups = this.props.groups;

    const parentSelector = () => document.querySelector('#app');
    let editableColumns;

    if (groups) {
      editableColumns = {
        group_id: {
          validValues: groups,
        },
      };
    }

    console.log(this.props.columns, members);

    return (
      <div>
        <Helmet>
          <title> Team members </title>
        </Helmet>

        <EditDivisionModal
          divisions={this.props.divisions}
          activeDivision={this.props.activeDivision}
          isOpen={this.props.editDivisionModalOpen}
          close={this.hideEditDivisionModal}
          parentSelector={parentSelector}
          refreshDivisions={this.refreshDivisions}
          selectDefault={this.selectDefaultDivision}
        />

        <div className="title-container">
          <h2>Team members</h2>
        </div>
        <div className="main-content-container">
          <ErrorMessage error={this.props.error} />
          <p>
            Collaborate with your co-workers on projects and design-templates for consistent branding. Invite
            collaborators to {this.props.team.name} below
          </p>

          <Table
            ref={this.table}
            columns={this.props.columns}
            rows={members}
            bulkActions={bulkActions}
            editableColumns={editableColumns}
            onRowSave={this.onRowSave}
            searchPlaceholder="Search for name and email"
            onSelectPageSize={this.onSelectPageSize}
            onSelectPage={this.onSelectPage}
            page={this.props.page}
            pageCount={this.props.pageCount}
            pageSize={this.props.pageSize}
            dataReturned={this.props.dataReturned}
            pagePosition="bottom"
            className={'page-bottom'}
            cantEdit={[this.props.team.owner_user]}
          />
          <hr />

          {this.props.checkPermission('team_management') && <TeamInvitationsPage ref={this.teamInvite} />}
        </div>
      </div>
    );
  }
}

TeamMembersPage.propTypes = {
  team: PropTypes.object.isRequired,
  groups: PropTypes.array,
  checkPermission: PropTypes.func,
  loadGroups: PropTypes.func,
  divisions: PropTypes.array,
  addDivision: PropTypes.func,
  division: PropTypes.object,
  reloadTeams: PropTypes.func,
};

export default TeamMembersPage;
